import { useState } from "react";
import { deletePersonFromMap } from "../../utilities/deletePersonFromMap";
import { useDetachPersonFromManagerMutation } from "../../../store/api/listManager.api";

export const useDetachPersonFromManager = () => {
  const [disconnectQuery, queryState] = useDetachPersonFromManagerMutation();
  const [fetchingDetachMapPersons, setFetchingDetachMapPersons] = useState<
    Record<number, boolean>
  >({});

  const onDetachPersonFromManager = async (
    managerId: number,
    humanId: number,
  ) => {
    try {
      setFetchingDetachMapPersons((prev) => ({ ...prev, [humanId]: true }));
      await disconnectQuery({ managerId, humanId }).unwrap();
      deletePersonFromMap(setFetchingDetachMapPersons, humanId);
    } catch (e) {
      deletePersonFromMap(setFetchingDetachMapPersons, humanId);
    }
  };

  return {
    queryState,
    onDetachPersonFromManager,
    fetchingDetachMapPersons,
  };
};
